/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'kickback': {
    width: 27,
    height: 32,
    viewBox: '0 0 27 32',
    data: '<path pid="0" d="M23.578 17a1 1 0 01.993.883l.007.117v6.992a1 1 0 01-.883.993l-.117.007H3.416L6.52 29.79a1 1 0 01-.05 1.322l-.092.085a1 1 0 01-1.322-.049l-.085-.092L.54 25.633a1 1 0 01-.075-1.161l.075-.105 4.36-5.336a1 1 0 011.622 1.163l-.073.102-3.019 3.696H22.58V18a1 1 0 01.883-.993l.116-.007zM21.584.275l.086.092L26.1 5.79a1 1 0 01.075 1.162l-.074.104-4.36 5.336a1 1 0 01-1.623-1.163l.074-.102 3.019-3.696H4.062v5.992a1 1 0 01-.883.993l-.116.007a1 1 0 01-.994-.883l-.006-.117V6.431a1 1 0 01.883-.993l.117-.007h20.162L20.12 1.633a1 1 0 01.05-1.322l.092-.085a1 1 0 011.321.05z" _fill="#000" fill-rule="nonzero"/>'
  }
})
